/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const tluxyApplyCartCount = (count) => {
    document.querySelectorAll('[data-tluxy-cart-count]').forEach((badge) => {
      const qty = Number(count) || 0;
      badge.textContent = qty;
      badge.classList.toggle('is-hidden', qty < 1);
      badge.hidden = qty < 1;
    });
  };

  const tluxyFetchCartCount = async () => {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      tluxyApplyCartCount(cart.item_count || 0);
    } catch (error) {
      // fail silently
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tluxyFetchCartCount, { once: true });
  } else {
    tluxyFetchCartCount();
  }

  document.addEventListener('theme:cart:loaded', tluxyFetchCartCount);
  document.addEventListener('theme:cart:refresh', tluxyFetchCartCount);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-add-to-cart], [data-item-remove], [data-quantity-plus], [data-quantity-minus], [name="checkout"]')) {
      window.setTimeout(tluxyFetchCartCount, 500);
      window.setTimeout(tluxyFetchCartCount, 1200);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-quantity-field], [data-quantity-select], .filter__input')) {
      window.setTimeout(tluxyFetchCartCount, 500);
    }
  });


  // T.LUXY V25.4: product descriptions carry warehouse data (barcode, internal code, gender) that customers should not see.
  const tluxyHideInternalSpecs = () => {
    if (!document.body.classList.contains('template-product')) return;
    const internal = /^\s*(codice a barre|barcode|codice|code|codice interno|internal code|genere|gender)\s*:/i;
    document.querySelectorAll('.product__accordion__inner li, .product__accordion__inner p, .product-description li').forEach((el) => {
      if (internal.test(el.textContent)) el.style.display = 'none';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tluxyHideInternalSpecs, { once: true });
  } else {
    tluxyHideInternalSpecs();
  }
  document.addEventListener('theme:variant:change', () => window.setTimeout(tluxyHideInternalSpecs, 300));


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();